import React from "react"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

import Button from "../button/button.js"
import { QRCodeModalConsumer } from "./qrcodeModalContext.js";

import styles from "./qrcodeModal.module.scss"

const QRCodeModalButton = ({ eventLabel }) => {
  const onClick = (handleShow) => {
    trackCustomEvent({
      category: "Text To Download",
      action: "Show Form",
      label: eventLabel,
      value: null
    })

    if (window.analytics) {
      window.analytics.track("Text To Download Pressed", {
        locationName: eventLabel,
      })
    }

    const isPartner = false
    handleShow(isPartner)
  }

  return (
    <QRCodeModalConsumer>
      {({ handleShow }) => {
          return (
            <Button
              rootClassName={styles.buttonRoot}
              onClick={() => onClick(handleShow)}
              disabled={false}
              loading={false}
            >
              <span className={styles.showTablet}>Get Till</span>
              <span className={styles.hideTablet}>
                Get Started with Till
              </span>
            </Button>
          )
        
      }}
    </QRCodeModalConsumer>
  )
}

export default QRCodeModalButton
